import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const PushLogo: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="PushLogo"
      illustration={
        <svg
          width={restProps.width ?? "48"}
          height={restProps.height ?? "48"}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M9.00053 18C10.034 18 10.9206 17.3814 11.314 16.4948C11.4097 16.2787 11.2505 16.0362 11.0138 16.0362H6.98642C6.75053 16.0362 6.5897 16.2787 6.6862 16.4948C7.08044 17.3814 7.96708 18 8.9997 18"
            fill="url(#paint0_linear_2966_8287)"
          />
          <path
            d="M15.1797 13.5973C14.5248 13.5973 13.9937 13.067 13.9937 12.4113V8.10264C13.9937 5.76768 12.3911 3.808 10.2261 3.26118C10.1469 2.64589 9.62151 2.16917 8.98395 2.16917C8.3464 2.16917 7.81772 2.65001 7.74101 3.2686C5.79783 3.77254 4.3157 5.41715 4.04847 7.44529C4.04435 7.47498 4.04022 7.50467 4.03692 7.53436C4.03197 7.57478 4.02785 7.61437 4.02455 7.65478C4.02125 7.69519 4.01795 7.73561 4.01548 7.77602C4.013 7.80984 4.01053 7.84283 4.00888 7.87747C4.00558 7.9451 4.00393 8.01438 4.00393 8.08367V12.4113C4.00393 13.0637 3.47772 13.5924 2.82697 13.5973C2.51603 13.5998 2.25952 13.839 2.25952 14.1507V14.1557C2.25952 14.4642 2.50943 14.7141 2.8179 14.7141H15.1764C15.4849 14.7141 15.7348 14.4642 15.7348 14.1557C15.7364 13.8481 15.4865 13.5981 15.1781 13.5981L15.1797 13.5973Z"
            fill="url(#paint1_linear_2966_8287)"
          />
          <path
            d="M12.5784 2.41001C13.9682 2.70775 15.0296 3.90451 15.1608 5.31983C15.1756 5.47654 15.3117 5.59448 15.4726 5.57881C15.5484 5.57139 15.6177 5.5351 15.6664 5.47654C15.715 5.41716 15.7381 5.34293 15.7307 5.26705C15.654 4.44062 15.3208 3.67605 14.7665 3.05416C14.2164 2.43888 13.5013 2.02154 12.698 1.84916C12.6774 1.84503 12.6576 1.84256 12.6378 1.84256C12.5058 1.84256 12.3862 1.93494 12.3582 2.06937C12.3252 2.22361 12.4233 2.37619 12.5784 2.40918V2.41001Z"
            fill="url(#paint2_linear_2966_8287)"
          />
          <path
            d="M12.8992 0.567448C15.0617 1.03097 16.7146 2.89333 16.9183 5.09549C16.9332 5.2522 17.0692 5.36932 17.2301 5.35447C17.306 5.34705 17.3752 5.31076 17.4239 5.2522C17.4726 5.19281 17.4957 5.11858 17.4882 5.0427C17.3761 3.82533 16.8837 2.69703 16.0671 1.78317C15.2564 0.875091 14.2023 0.261454 13.0196 0.00742221C12.999 0.00329831 12.9792 0.000823975 12.9594 0.000823975C12.8274 0.000823975 12.7078 0.0931994 12.6798 0.227639C12.6459 0.381872 12.7441 0.534457 12.8992 0.567448Z"
            fill="url(#paint3_linear_2966_8287)"
          />
          <path
            d="M5.42097 2.41001C5.57521 2.37702 5.67418 2.22361 5.64119 2.06937C5.61232 1.93494 5.49355 1.84256 5.36159 1.84256C5.3418 1.84256 5.322 1.84503 5.30138 1.84916C4.49805 2.02154 3.78296 2.43805 3.23283 3.05416C2.67858 3.6744 2.34454 4.43979 2.26867 5.26705C2.26124 5.34293 2.28516 5.41716 2.333 5.47654C2.38084 5.53592 2.45094 5.57222 2.52682 5.57881C2.68765 5.59366 2.82374 5.47654 2.83859 5.31983C2.96973 3.90533 4.03204 2.7094 5.42097 2.41083V2.41001Z"
            fill="url(#paint4_linear_2966_8287)"
          />
          <path
            d="M5.10008 0.567449C5.25431 0.534458 5.35329 0.381048 5.3203 0.226815C5.29143 0.0923754 5.17266 0 5.0407 0C5.02008 0 5.00111 0.00247433 4.98049 0.00659824C3.79693 0.260631 2.74368 0.874267 1.93293 1.78235C1.11557 2.69703 0.624824 3.82451 0.511829 5.04188C0.504406 5.11776 0.528325 5.19199 0.576162 5.25138C0.624824 5.31076 0.694106 5.34705 0.769985 5.35365C0.929993 5.36849 1.06691 5.25138 1.08175 5.09467C1.28547 2.89333 2.93833 1.0318 5.10008 0.567449Z"
            fill="url(#paint5_linear_2966_8287)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2966_8287"
              x1="11.7075"
              y1="11.7746"
              x2="8.41081"
              y2="17.3781"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2966_8287"
              x1="15.2721"
              y1="3.58366"
              x2="5.37636"
              y2="15.9842"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_2966_8287"
              x1="18.8871"
              y1="0.496518"
              x2="2.00142"
              y2="11.7045"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_2966_8287"
              x1="18.7287"
              y1="0.258155"
              x2="1.84297"
              y2="11.4661"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_2966_8287"
              x1="15.734"
              y1="-4.25421"
              x2="-1.1517"
              y2="6.95455"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_2966_8287"
              x1="14.9042"
              y1="-5.50293"
              x2="-1.97323"
              y2="5.70088"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.17" stopColor="#EA6AC0" />
              <stop offset="0.33" stopColor="#DA4AD5" />
              <stop offset="0.42" stopColor="#D53EDD" />
              <stop offset="0.53" stopColor="#CB3EDD" />
              <stop offset="0.72" stopColor="#B341E0" />
              <stop offset="0.95" stopColor="#8B45E4" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default PushLogo;
